module.exports = __webpack_public_path__ + "static/media/PW.0181cbdb.png";